import { forwardRef } from "react";

const ShimmerButton = forwardRef(({ children, className = "", ...props }, ref) => {
  return (
    <button
      ref={ref}
      className={`
        relative inline-flex items-center justify-center px-6 py-3 font-medium text-white
        bg-deep-green hover:bg-forest-green rounded-lg transition-all duration-200
        overflow-hidden group focus:outline-none focus:ring-2 focus:ring-deep-green focus:ring-offset-2
        ${className}
      `}
      {...props}
    >
      {/* Shimmer overlay */}
      <div className="absolute inset-0 -top-2 -bottom-2 bg-gradient-to-r from-transparent via-white/20 to-transparent 
                      transform -skew-x-12 translate-x-[-100%] group-hover:translate-x-[400%] transition-transform duration-1000 ease-out" />
      
      {/* Content */}
      <span className="relative z-10">{children}</span>
    </button>
  );
});

ShimmerButton.displayName = "ShimmerButton";

export default ShimmerButton;
